module.exports = __webpack_public_path__ + "static/media/electric-blue.3e7585fa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/colours/electric-blue.jpg
// module id = 128
// module chunks = 0